/** Agrupa um array de objetos por determinada propriedade
 * Ex:
 * array = [{id:"1"}, {id:"2"}]
 * agruparPor(array, "id")
 */
export const agruparPor = (objetoArray, propriedade) =>
  objetoArray.reduce((acc, obj) => {
    const key = obj[propriedade];

    if (!acc[key]) acc[key] = [];
    acc[key].push(obj);

    return acc;
  }, {});

//DIAS DA SEMANA
const weekDays = () => [
  { name: "Domingo", initials: "Dom", value: 1 },
  { name: "Segunda", initials: "Seg", value: 2 },
  { name: "Terça", initials: "Ter", value: 3 },
  { name: "Quarta", initials: "Qua", value: 4 },
  { name: "Quinta", initials: "Qui", value: 5 },
  { name: "Sexta", initials: "Sex", value: 6 },
  { name: "Sabado", initials: "Sab", value: 7 }
];

//MESES DO ANO
const months = () => [
  { name: "Janeiro", initials: "Jan", value: 1 },
  { name: "Fevereiro", initials: "Fev", value: 2 },
  { name: "Março", initials: "Mar", value: 3 },
  { name: "Abril", initials: "Abr", value: 4 },
  { name: "Maio", initials: "Mai", value: 5 },
  { name: "Junho", initials: "Jun", value: 6 },
  { name: "Julho", initials: "Jul", value: 7 },
  { name: "Agosto", initials: "Ago", value: 8 },
  { name: "Setembro", initials: "Set", value: 9 },
  { name: "Outubro", initials: "Out", value: 10 },
  { name: "Novembro", initials: "Nov", value: 11 },
  { name: "Dezembro", initials: "Dez", value: 12 }
];

//ESTADOS DO BRASIL
const statesFromCountry = [
  { id: 1, initials: "AC", name: "Acre" },
  { id: 2, initials: "AL", name: "Alagoas" },
  { id: 3, initials: "AM", name: "Amazonas" },
  { id: 4, initials: "AP", name: "Amapá" },
  { id: 5, initials: "BA", name: "Bahia" },
  { id: 6, initials: "CE", name: "Ceará" },
  { id: 7, initials: "DF", name: "Distrito Federal" },
  { id: 8, initials: "ES", name: "Espírito Santo" },
  { id: 9, initials: "GO", name: "Goiás" },
  { id: 10, initials: "MA", name: "Maranhão" },
  { id: 11, initials: "MG", name: "Minas Gerais" },
  { id: 12, initials: "MS", name: "Mato Grosso do Sul" },
  { id: 13, initials: "MT", name: "Mato Grosso" },
  { id: 14, initials: "PA", name: "Pará" },
  { id: 15, initials: "PB", name: "Paraíba" },
  { id: 16, initials: "PE", name: "Pernambuco" },
  { id: 17, initials: "PI", name: "Piauí" },
  { id: 18, initials: "PR", name: "Paraná" },
  { id: 19, initials: "RJ", name: "Rio de Janeiro" },
  { id: 20, initials: "RN", name: "Rio Grande do Norte" },
  { id: 21, initials: "RO", name: "Rondônia" },
  { id: 22, initials: "RR", name: "Roraima" },
  { id: 23, initials: "RS", name: "Rio Grande do Sul" },
  { id: 24, initials: "SC", name: "Santa Catarina" },
  { id: 25, initials: "SE", name: "Sergipe" },
  { id: 26, initials: "SP", name: "São Paulo" },
  { id: 27, initials: "TO", name: "Tocantins" }
];

export const maskTel8Digit = ["(", /\d/, /\d/, ") ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
export const maskTel9Digit = ["(", /\d/, /\d/, ") ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

export const maskTel8DigitRegion = [
  "+",
  "5",
  "5",
  " ",
  "(",
  /[0-9]/,
  /[0-9]/,
  ")",
  " ",
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  "-",
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/
];

export const maskTel9DigitRegion = [
  "+",
  "5",
  "5",
  " ",
  "(",
  /[0-9]/,
  /[0-9]/,
  ")",
  " ",
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  "-",
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/
];

export function maskTelFull(value) {
  if (value.length <= 18) return maskTel8DigitRegion;
  return maskTel9DigitRegion;
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor;

  return /android|webOS|iPhone|iPad|iPod|BlackBerry|BB10|RIM|Windows Phone|Kindle|Silk|Opera Mini|Mobile|MiuiBrowser|XiaoMi|Redmi|MiPhone|SAMSUNG|SGH|Galaxy|HUAWEI|Honor/i.test(
    userAgent
  );
}

const preposicoes = ["da", "das", "do", "dos", "de", "a", "as", "o", "os", "e"];
export function capitalize(text) {
  return text
    .split(" ")
    .map(e =>
      preposicoes.includes(e.toLowerCase())
        ? e.toLowerCase()
        : e.length
        ? e[0].toUpperCase() + e.slice(1).toLowerCase()
        : ""
    )
    .join(" ");
}

export const injectOnePixelImage = () => {
  if (document.getElementById("onepixel")) return;
  const code = `var i=new Image,u="https://s3-sa-east-1.amazonaws.com/frame-image-br/bg.png?x-id=8d06d4792ef7a384bf044db6d1b31311&x-r="+document.referrer+"&x-s="+window.location.href;i.src=u;`;
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("id", "onepixel");
  script.textContent = code;
  document.head.appendChild(script);
};

export const removeOnePixelImage = () => {
  const script = document.getElementById("onepixel");
  if (script) {
    document.head.removeChild(script);
  }
};

export const capitalizeWords = inputString => {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
};

export default {
  agruparPor,
  weekDays,
  months,
  statesFromCountry,
  maskTelFull,
  maskTel8Digit,
  maskTel9Digit,
  isMobile
};
